import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";
import { ScientistOfTheDayListing } from "./ScientistOfTheDayListing";
import { KontentComponentSettings } from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { useScientists } from "../../../lib/useScientists";

interface Props extends KontentComponentSettings {}

const ScientistOfTheDayListingContainer: React.FC<Props> = ({
  id,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
}) => {
  const SCIENTISTS_PAGINATED_COLLECTION_ROUTE = "/paginated-collections/";
  const scientistsQuery = useScientists();
  const scientists = scientistsQuery.scientists;
  const pages = scientistsQuery.pages;

  const [visibleScientists, setVisibleScientists] = useState(scientists);
  const [nextPage, setNextPage] = useState(pages[0]);
  const [loadMore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(nextPage.hasNextPage);

  useEffect(() => {
    const fetchScientists = async () => {
      await fetch(SCIENTISTS_PAGINATED_COLLECTION_ROUTE + nextPage.id + ".json")
        .then((response) => response.json())
        .then((data) =>
          setVisibleScientists([...visibleScientists, ...data.nodes])
        );
    };

    if (loadMore && hasMore) {
      fetchScientists();

      if (nextPage.hasNextPage) {
        setNextPage(pages[nextPage.index + 1]);
      } else {
        setHasMore(false);
      }

      setLoadMore(false);
    }
  }, [loadMore]);

  return (
    <ScientistOfTheDayListing
      scientists={visibleScientists}
      id={id}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      hasMore={hasMore}
      setLoadMore={setLoadMore}
    />
  );
};

export default ScientistOfTheDayListingContainer;

export const fragmentScientistOfTheDayListing = graphql`
  fragment ScientistOfTheDayListing on kontent_item_component___scientist_of_the_day_listing {
    elements {
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
